module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-18.e4d74513.png";